import * as React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';

interface DeleteReportDialogProps {
    open: boolean;
    onCancel: () => void;
    onConfirm: () => void;
    isDeleting?: boolean;
    title?: string;
    message?: string;
}

const DeleteReportDialog: React.FC<DeleteReportDialogProps> = ({
    open,
    onCancel,
    onConfirm,
    isDeleting = false,
    title = "Delete Report",
    message = "Are you sure you want to delete this report? This action cannot be undone."
}) => {
    return (
        <Dialog
            open={open}
            onClose={onCancel}
        >
            <DialogTitle>{title}</DialogTitle>
            <DialogContent>
                <DialogContentText>
                    {message}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button 
                    onClick={onCancel}
                    color="secondary"
                    disabled={isDeleting}
                >
                    Cancel
                </Button>
                <Button 
                    onClick={onConfirm}
                    color="primary"
                    variant="contained"
                    disabled={isDeleting}
                >
                    Delete
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default DeleteReportDialog;